module.exports = __webpack_public_path__ + "static/media/a.4aad6e72.png";